// @ts-nocheck

export const localeCodes =  [
  "de"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46js_f6d0e469",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

